module.exports = __webpack_public_path__ + "img/icon_shoubi_normal@2x.90e680b2.png";